



































import {
	defineComponent,
	Ref,
	ref,
} from '@vue/composition-api';
import TrModal from '@front-app/components/modals/TrModal.vue';
import { Cropper, CircleStencil } from 'vue-advanced-cropper';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import 'vue-advanced-cropper/dist/style.css';
import { Size } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { CurrentUserStore, UserAvatarStore } from '@front-app/store/singletons/User';
import { blobToFile } from '@front-app/util/image';
import { ImageScale } from '@front-app/services/ImageApi/ImageModel';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

export default defineComponent({
	components: {
		TrModal,
		Cropper,
		CtaButton,
	},
	props: {
		imageUrl: {
			type: String,
			required: true,
		},
		mimeType: {
			type: String,
			required: true,
		},
		isOpen: Boolean,
	},
	setup(props, ctx) {
		const cropper: Ref<null | Cropper> = ref(null);
		const performSave = async () => {
			const cropperVal = cropper.value;
			if (!cropperVal) {
				return;
			}
			const { canvas } = cropperVal.getResult();
			canvas.toBlob(async (blob) => {
				if (!blob) {
					return;
				}
				await CurrentUserStore.actions.updateAvatar(blobToFile(blob, 'user-avatar'));
				await UserAvatarStore.invalidate(CurrentUserStore.currentUser.value.id, ImageScale.LARGE_4X);
			}, props.mimeType);
		};
		const {
			track,
			isLoading,
		} = useAsyncStatus();
		const save = async () => {
			// eslint-disable-next-line no-alert
			const shouldProceed = window.confirm('Permanently change your user profile picture?');
			if (!shouldProceed) {
				return;
			}
			await track(performSave());
			ctx.emit('close');
		};
		return {
			save,
			isLoading,
			cropper,
			stencil: CircleStencil,
			Size,
			ButtonPalettes,
		};
	},
});
